import type { RouteNameType } from '@/router/routeNames';
import { ref } from 'vue';

export type breadcrumb = {
    sprachcode: string;
    icon?: string;

    // Zielroute per Routenname; kunde-Param ergänzt die Topbar automatisch
    routeName?: RouteNameType;
    routeQuery?: Record<string, any>;

    // Parameter für die Übersetzung (z. B. Probennummer)
    sprachcodeParams?: Record<string, any>;
};

const breadcrumbItems = ref<breadcrumb[]>([]);

export function useBreadcrumbs() {
    const setBreadcrumbs = (crumbs: breadcrumb[]) => {
        breadcrumbItems.value = crumbs;
    };

    const clearBreadcrumbs = () => {
        breadcrumbItems.value = [];
    };

    return { breadcrumbItems, setBreadcrumbs, clearBreadcrumbs };
}
